<template>
  <div class="card-item-wrapper p-d-12">
    <div class="card-item">
      <div class="f-regular f-12 f-c-yellow konfirmasi-penghapusan"
           v-if="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0">
        Menunggu konfirmasi penghapusan
      </div>
      <div class="top-card">
        <div class="f-semi f-16 f-c-black" v-if="!isSearch">{{ transaksi.idtransaksi }}</div>
        <div class="f-semi f-16 f-c-black" v-else
             v-html="searchHighlight(transaksi.idtransaksi, keySearch)"></div>
        <div class="card-menu-vertical"></div>
      </div>
      <div class="f-regular f-13 m-t-4">
        <img src="../../../assets/icons/mood-happy.svg" alt=""
             class="m-r-4"
             style="height: 13px; margin-top: -2px"
        />
        <span class="f-c-midgrey" v-if="!isSearch">{{ transaksi.nama_customer }}</span>
        <span class="f-c-black" v-else v-html="searchHighlight(transaksi.nama_customer, keySearch)"></span>
      </div>
      <div class="f-regular f-13 f-c-midgrey m-r-8">
        <img src="../../../assets/icons/ticket.svg" alt=""
             class="m-r-4"
             style="height: 13px; margin-top: -2px"
        />
        <span>
					{{ transaksi.detail_epayment[0].nama_paket_epayment }}
				</span>
        <span v-if="transaksi.detail_epayment.length > 1">
					+ {{ transaksi.detail_epayment.length - 1 }} paket lain
				</span>
      </div>
      <div class="f-regular f-13 f-c-midgrey">
        <img src="../../../assets/icons/outlet-out-muted.svg" alt=""
             class="m-r-4"
             style="height: 13px; margin-top: -2px"
        />
        <span v-if="!isSearch">{{ transaksi.nama_outlet }}</span>
        <span class="f-c-black" v-else v-html="searchHighlight(transaksi.nama_outlet, keySearch)"></span>
      </div>
      <div class="f-regular f-13 f-c-midgrey">
        Diterima: {{ transaksi.waktu_diterima }}
      </div>

      <div class="separator-line m-x-min m-t-10"></div>
      <div class="bottom-card m-t-8 d-flex-between-center align-items-center" style="position: relative">
        <div class="d-inline">
					<span class="f-semi f-14 f-c-black" v-if="transaksi.total_harga !== undefined">
						{{ transaksi.total_harga | currency }}
					</span>
          <span class="badge color-green" v-if="transaksi.status_lunas === 1">Lunas</span>
          <span class="badge color-green" v-else>Blm Lunas</span>
        </div>
        <div class="f-regular f-12 f-c-midgrey">
          Saldo {{ transaksi.saldo | currency }}
        </div>
      </div>
      <div
          v-if="transaksi['is_loyalty']=== 1"
          :id="`card_footer_detail_epayment${transaksi.id}`"
          class="employee card_footer f-12 f-c-secondary-kasir-smartlink f-regular m-x-min confirmed"
      >
        <img
            src="@/assets/icons/ic_phone_whitelabel.svg"
            alt=""
            class="m-r-4"
            style="height: 13px; margin-top: -2px"
        /> Loyalty Apps
      </div>

      <div class="clik"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
      </div>
      <div class="dropdown-menu garis-listkomisi">
        <button
            class="dropdown-item icon-2"
            v-if="validateAccess('topupEpayment.read')"
            @click="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0 ? konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event) : detail(transaksi.idtransaksi, $event)"
        >
					<span class="mar-right-10">
						<img src="../../../assets/icons/file-text.svg">
					</span>
          Detail Nota
        </button>
        <button class="dropdown-item icon-2" @click="konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event)"
                v-if="transaksi.status_hapus === 1 && validateAccess('deleteTopupEpayment.confirm')"
        >
						<span class="mar-right-10">
							<img src="../../../assets/icons/clipboard-check.svg">
						</span>
          <b>Konfirmasi</b>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SOProgressBarCircle from "@/so-components/global/ui/SOProgressBarCircle";

export default {
  name: "SOCardTopupEpayment",
  components: {
    SOProgressBarCircle
  },
  props: {
    transaksi: Object,
    isSearch: Boolean,
    keySearch: String,
  },
  methods: {
    detail(id, event) {
      this.$store.commit("epaymentModule/setScrollPosition", event.pageY)
      this.$router.push("/transaksi/epayment/topup/" + id)
      this.smartTrackingClick("detail_top_up_e-payment");
    },
    konfirmasiPenghapusan(id, event) {
      this.$store.commit("epaymentModule/setScrollPosition", event.pageY)
      this.$router.push({
        name: "PembatalanTopupEpayment.detail.data",
        params: {id: id},
        query: {back: "TopupEpayment"}
      });
      this.smartTrackingClick("konfirmasi_hapus_top_up_e-payment");
    }
  }
}
</script>

<style scoped>
.konfirmasi-penghapusan {
  background: linear-gradient(90deg, #FFF8E1 0%, #FFFFFF 100%);
  padding: 4px 18px;
  margin: -10px -18px 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.card-item .employee,
.detail .detail-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  margin: 10px -18px -10px -18px !important;
  padding: 8px 18px !important;
  background-image: linear-gradient(to right, #E5F6F5, #FFFFFF);
}
</style>